export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string[];
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  language: string;
  releaseDate: string;
  image: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  isClassic: boolean;
}

export const categories = [
  { key: 'huayu', label: '华语电影', icon: 'ri-china-railway-line' },
  { key: 'oumei', label: '欧美电影', icon: 'ri-global-line' },
  { key: 'rihan', label: '日韩电影', icon: 'ri-sun-line' },
  { key: 'jingdian', label: '经典电影', icon: 'ri-award-line' },
  { key: 'zuixin', label: '最新上映', icon: 'ri-fire-line' },
  { key: 'gaofen', label: '高分推荐', icon: 'ri-star-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球2',
    year: 2023,
    category: ['huayu', 'zuixin', 'gaofen'],
    rating: 8.3,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对宇宙危机，人类再次踏上前途未卜的流浪之旅。',
    longDescription: '在不远的将来，太阳急速衰老膨胀，整个太阳系将被其吞没。为了自救，人类提出名为"流浪地球"的大胆计划——在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，奔向4.2光年外的新家园。本片讲述了地球开始流浪之后，人类面临的一系列前所未有的挑战。太空电梯危机、月球坠落危机、木星引力危机接踵而至，人类必须团结一致才能渡过难关。影片以宏大的科幻视角展现了人类在绝境中的勇气与智慧，同时也探讨了亲情、责任与希望等永恒主题。视觉效果震撼，是中国科幻电影的里程碑之作。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    duration: '173分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-01-22',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20style%2C%20dramatic%20space%20scene%20with%20planet%20earth%20and%20massive%20engines%2C%20futuristic%20space%20station%2C%20warm%20golden%20light%20against%20dark%20cosmic%20background%2C%20epic%20scale%2C%20movie%20poster%20composition%2C%20dramatic%20lighting%2C%20cinematic%20color%20grading%20with%20deep%20blacks%20and%20golden%20highlights&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    tags: ['科幻', '灾难', '冒险', '中国科幻'],
    featured: true,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-2',
    title: '奥本海默',
    year: 2023,
    category: ['oumei', 'zuixin', 'gaofen'],
    rating: 8.8,
    description: '聚焦"原子弹之父"罗伯特·奥本海默的传奇一生，从曼哈顿计划到核爆试验，再到战后政治迫害的心路历程。',
    longDescription: '影片改编自凯·伯德和马丁·J·舍温所著《奥本海默传："原子弹之父"的美国悲剧》，讲述了美国"原子弹之父"罗伯特·奥本海默主导制造出世界上第一颗原子弹的故事。故事围绕奥本海默在二战期间领导曼哈顿计划、在新墨西哥州洛斯阿拉莫斯实验室研发原子弹的经历展开，同时也深入探讨了战后他因政治立场遭受调查和迫害的黑暗时期。导演克里斯托弗·诺兰以标志性的非线性叙事和震撼的IMAX摄影，呈现了这位复杂历史人物的内心世界。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国/英国',
    language: '英语',
    releaseDate: '2023-07-21',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20biographical%20movie%20poster%2C%20silhouette%20of%20a%20man%20in%20fedora%20hat%20against%20mushroom%20cloud%20explosion%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20intense%20cinematic%20lighting%2C%20minimalist%20design%2C%20vintage%201940s%20aesthetic&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    tags: ['传记', '历史', '剧情', '诺兰'],
    featured: true,
    isNew: true,
    isClassic: false,
  },
  {
    id: 'movie-3',
    title: '肖申克的救赎',
    year: 1994,
    category: ['oumei', 'jingdian', 'gaofen'],
    rating: 9.7,
    description: '银行家安迪因被误判杀害妻子及其情人而锒铛入狱，在肖申克监狱中凭借才智和毅力，最终重获自由的故事。',
    longDescription: '1947年，银行家安迪·杜佛兰被指控枪杀妻子及其情人，被判无期徒刑，关进肖申克监狱。在监狱中，他结识了囚犯瑞德，两人成为挚友。安迪凭借金融才能帮助监狱官避税，逐渐获得特殊待遇。二十年间，安迪表面上适应了监狱生活，暗中却用一把小锤子挖通了一条逃生隧道。影片最终揭示了安迪惊人的越狱计划和他对自由的执着追求，被誉为影史最伟大的电影之一。',
    director: '弗兰克·德拉邦特',
    cast: ['蒂姆·罗宾斯', '摩根·弗里曼', '鲍勃·冈顿'],
    duration: '142分钟',
    region: '美国',
    language: '英语',
    releaseDate: '1994-09-23',
    image: 'https://readdy.ai/api/search-image?query=Classic%20movie%20poster%20style%2C%20man%20standing%20in%20rain%20with%20arms%20outstretched%20feeling%20freedom%2C%20dark%20dramatic%20lighting%2C%20golden%20warm%20tones%2C%20prison%20silhouette%20in%20background%2C%20cinematic%20composition%2C%20hope%20and%20redemption%20theme&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    tags: ['剧情', '犯罪', '励志', '经典'],
    featured: true,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-4',
    title: '千与千寻',
    year: 2001,
    category: ['rihan', 'jingdian', 'gaofen'],
    rating: 9.4,
    description: '少女千寻意外来到神灵异世界，为了拯救变成猪的父母，她在汤屋中工作，经历了一段奇幻的冒险旅程。',
    longDescription: '10岁的少女千寻与父母在搬家途中误入了一个神秘的小镇。天色渐晚，父母被美食诱惑大快朵颐，结果变成了猪。千寻为了拯救父母，在汤婆婆经营的"油屋"中寻找工作，被改名为"千"。在白龙的帮助下，千寻逐渐适应了这个世界，并在工作中展现出了勇气和善良。宫崎骏的这部杰作获得了奥斯卡最佳动画长片奖，以其丰富的想象力、深刻的人性洞察和精美的画面成为动画史上的巅峰之作。',
    director: '宫崎骏',
    cast: ['柊瑠美', '入野自由', '夏木真理'],
    duration: '125分钟',
    region: '日本',
    language: '日语',
    releaseDate: '2001-07-20',
    image: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20style%2C%20young%20girl%20in%20traditional%20Japanese%20bathhouse%20setting%2C%20magical%20spirits%20and%20dragons%2C%20warm%20golden%20and%20red%20color%20palette%2C%20Studio%20Ghibli%20inspired%20illustration%2C%20dreamy%20atmosphere%2C%20Japanese%20architecture%20background&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '宫崎骏'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-5',
    title: '封神第一部：朝歌风云',
    year: 2023,
    category: ['huayu', 'zuixin'],
    rating: 7.8,
    description: '殷商末年，纣王暴虐无道。昆仑仙人姜子牙携封神榜下山，助西岐武王伐纣，一场神魔大战拉开序幕。',
    longDescription: '影片改编自中国古典神魔小说《封神演义》。殷商末年，纣王殷寿暴虐无道，天怒人怨。昆仑山玉虚宫元始天尊命弟子姜子牙携封神榜下山，辅佐明君。西伯侯姬昌之子姬发逃回西岐，在姜子牙的辅佐下起兵伐纣。影片以宏大的神话史诗视角，展现了人、仙、妖三界的纷争。特效制作精良，战争场面气势磅礴，是中国神话史诗电影的全新尝试。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '148分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-07-20',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20movie%20poster%2C%20ancient%20Chinese%20warrior%20in%20elaborate%20armor%20riding%20horse%2C%20dramatic%20battlefield%20with%20fire%20and%20smoke%2C%20golden%20and%20crimson%20color%20scheme%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20epic%20scale&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    tags: ['神话', '史诗', '动作', '奇幻'],
    featured: false,
    isNew: true,
    isClassic: false,
  },
  {
    id: 'movie-6',
    title: '寄生虫',
    year: 2019,
    category: ['rihan', 'gaofen'],
    rating: 8.8,
    description: '一个贫穷家庭的四个成员相继潜入一个富人家中工作，两个阶层的碰撞引发了一系列意想不到的事件。',
    longDescription: '基泽一家四口全部失业，生活在半地下室中。机缘巧合下，长子基宇伪造学历成为富豪朴社长家的家教。随后，全家人用计谋相继进入朴家工作：妹妹成为美术老师，父亲成为司机，母亲成为管家。两个阶层的家庭在同一个屋檐下产生了微妙的化学反应。奉俊昊导演以黑色幽默和悬疑手法，深刻揭示了韩国社会的阶级矛盾。该片荣获第92届奥斯卡最佳影片等四项大奖，创造了非英语电影的历史。',
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植', '朴素丹'],
    duration: '132分钟',
    region: '韩国',
    language: '韩语',
    releaseDate: '2019-05-30',
    image: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20movie%20poster%20style%2C%20Korean%20family%20drama%2C%20staircase%20symbolism%2C%20contrast%20between%20rich%20and%20poor%2C%20modern%20architecture%20and%20basement%2C%20tense%20atmosphere%2C%20black%20and%20dark%20green%20color%20scheme%2C%20Oscar-winning%20aesthetic&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    tags: ['剧情', '悬疑', '黑色幽默', '奥斯卡'],
    featured: false,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-7',
    title: '盗梦空间',
    year: 2010,
    category: ['oumei', 'jingdian', 'gaofen'],
    rating: 9.3,
    description: '专业窃贼柯布能够在人们梦境中盗取秘密，这次他接到一个不可能的任务——在目标对象的潜意识中植入一个想法。',
    longDescription: '道姆·柯布是一名"盗梦者"，能够潜入他人梦境窃取潜意识中的秘密。因被指控谋杀妻子而流亡海外，无法回到美国与孩子团聚。日本商人齐藤向他提出一个条件：完成"植入"任务——在竞争对手费舍尔的潜意识中植入一个想法，就可以帮他洗清罪名。柯布组建了一支精英团队，通过层层嵌套的梦境深入目标的潜意识。诺兰以其标志性的复杂叙事结构，创造了一个关于记忆、现实与潜意识的烧脑杰作。',
    director: '克里斯托弗·诺兰',
    cast: ['莱昂纳多·迪卡普里奥', '约瑟夫·戈登-莱维特', '艾伦·佩吉', '汤姆·哈迪'],
    duration: '148分钟',
    region: '美国/英国',
    language: '英语',
    releaseDate: '2010-07-16',
    image: 'https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20movie%20poster%2C%20cityscape%20folding%20onto%20itself%2C%20surreal%20dream%20architecture%2C%20dark%20blue%20and%20silver%20color%20tones%2C%20minimalist%20design%2C%20labyrinth%20concept%2C%20zen%20garden%20elements%2C%20cinematic%20composition&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    tags: ['科幻', '悬疑', '动作', '烧脑'],
    featured: true,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-8',
    title: '你好，李焕英',
    year: 2021,
    category: ['huayu', 'gaofen'],
    rating: 7.9,
    description: '2001年的某一天，刚考上大学的贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇，展开了一段感人至深的母女情。',
    longDescription: '2001年，刚考上大学的贾晓玲遭遇了人生中的重大打击——母亲李焕英遭遇意外。悲痛中的贾晓玲意外穿越到了1981年，来到了母亲年轻时的工厂，与正值青春年华的母亲相遇。贾晓玲以表妹的身份融入母亲的生活，决心让母亲"更开心"，帮母亲改变命运。她撮合母亲与厂长儿子沈光林，希望母亲能有更好的人生。然而，结局的反转令人泪目——母亲其实也穿越了，她一直知道女儿的身份。',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫'],
    duration: '128分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2021-02-12',
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20comedy-drama%20movie%20poster%2C%201980s%20vintage%20Chinese%20factory%20setting%2C%20mother-daughter%20bond%2C%20warm%20golden%20nostalgic%20lighting%2C%20retro%20Chinese%20aesthetic%2C%20emotional%20and%20sweet%20atmosphere&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    tags: ['喜剧', '亲情', '穿越', '感人'],
    featured: false,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-9',
    title: '教父',
    year: 1972,
    category: ['oumei', 'jingdian', 'gaofen'],
    rating: 9.3,
    description: '维托·柯里昂是纽约黑手党柯里昂家族的掌门人，小儿子迈克尔在家族变故中逐渐成长为新一代教父。',
    longDescription: '故事发生在1945年至1955年间的纽约。维托·柯里昂是黑手党柯里昂家族的首领，被称为"教父"。他虽从事非法勾当，但坚持原则，拒绝参与毒品生意。这引来其他家族的暗杀企图。教父的小儿子迈克尔原本远离家族事务，但在父亲遇刺后，他被迫卷入黑帮斗争，一步步蜕变为冷酷果断的新一代教父。弗朗西斯·科波拉的这部黑帮史诗不仅是一部犯罪片，更是一部关于家庭、权力和美国梦的深刻寓言。马龙·白兰度和阿尔·帕西诺的表演成为影史经典。',
    director: '弗朗西斯·福特·科波拉',
    cast: ['马龙·白兰度', '阿尔·帕西诺', '詹姆斯·凯恩', '罗伯特·杜瓦尔'],
    duration: '175分钟',
    region: '美国',
    language: '英语/意大利语',
    releaseDate: '1972-03-24',
    image: 'https://readdy.ai/api/search-image?query=Classic%20mafia%20movie%20poster%20style%2C%20dark%20silhouette%20of%20man%20in%20tuxedo%20with%20red%20rose%2C%20puppet%20strings%20symbolism%2C%20vintage%201970s%20aesthetic%2C%20dark%20crimson%20and%20black%20color%20palette%2C%20dramatic%20theatrical%20lighting&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    tags: ['黑帮', '剧情', '经典', '奥斯卡'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-10',
    title: '你的名字',
    year: 2016,
    category: ['rihan', 'gaofen'],
    rating: 8.4,
    description: '生活在乡下的三叶和东京的高中生泷，两人在梦中互换身体，展开了一段跨越时空的奇幻爱情故事。',
    longDescription: '生活在日本乡下小镇的高中女生宫水三叶，对单调的生活感到厌倦，梦想来世能成为东京的帅哥。某天她真的做了一个变成东京男高中生的梦。与此同时，在东京生活的高中生立花泷也做了一个去乡下小镇变成女高中生的梦。两人发现他们真的在梦中互换了身体，于是开始通过手机留言交流。然而当泷试图去找三叶时，却发现了一个惊人的真相。新海诚以唯美的画面和动人的音乐，讲述了一个关于命运、时间和爱的故事。',
    director: '新海诚',
    cast: ['神木隆之介', '上白石萌音'],
    duration: '106分钟',
    region: '日本',
    language: '日语',
    releaseDate: '2016-08-26',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20movie%20poster%2C%20boy%20and%20girl%20reaching%20toward%20each%20other%20under%20starry%20sky%2C%20comet%20streaking%20across%20sky%2C%20beautiful%20twilight%20gradient%20colors%2C%20Japanese%20countryside%20and%20Tokyo%20skyline%20blend%2C%20dreamy%20atmosphere&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    tags: ['动画', '爱情', '奇幻', '新海诚'],
    featured: false,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-11',
    title: '长津湖',
    year: 2021,
    category: ['huayu', 'gaofen'],
    rating: 7.4,
    description: '抗美援朝战争中，中国志愿军第九兵团在极度严寒和装备落后的条件下，与美军在长津湖展开殊死搏斗。',
    longDescription: '1950年，抗美援朝战争第二次战役中，中国人民志愿军第九兵团在朝鲜长津湖地区，与装备精良的美军展开了一场震撼人心的殊死较量。在零下四十度的极寒天气下，志愿军战士以钢铁般的意志坚守阵地，"冰雕连"的事迹感天动地。影片以恢弘的战争场面和细腻的人物刻画，展现了志愿军战士保家卫国的壮烈情怀，创造了中国影史票房纪录。',
    director: '陈凯歌 / 徐克 / 林超贤',
    cast: ['吴京', '易烊千玺', '段奕宏', '朱亚文', '李晨'],
    duration: '176分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2021-09-30',
    image: 'https://readdy.ai/api/search-image?query=Epic%20war%20movie%20poster%20style%2C%20Chinese%20soldiers%20in%20snowy%20battlefield%2C%20winter%20mountain%20landscape%2C%20dramatic%20battle%20scene%2C%20cold%20blue%20and%20white%20with%20fire%20explosions%2C%20patriotic%20theme%2C%20cinematic%20scale&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    tags: ['战争', '历史', '动作', '爱国'],
    featured: false,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-12',
    title: '泰坦尼克号',
    year: 1997,
    category: ['oumei', 'jingdian', 'gaofen'],
    rating: 9.4,
    description: '1912年泰坦尼克号首航中，贵族少女罗丝与穷画家杰克在船上相遇相爱，然而巨轮撞上冰山，两人的爱情面临生死考验。',
    longDescription: '1912年4月，被称为"不沉之船"的泰坦尼克号从英国南安普顿出发，驶往美国纽约。贵族少女罗丝因不满包办婚姻而企图跳海自杀，被穷画家杰克所救。两人在短短几天内坠入爱河。然而，泰坦尼克号在航行中撞上冰山，巨轮逐渐沉没。在生死关头，杰克把生的希望留给了罗丝。八十四年后，老年罗丝回忆起这段刻骨铭心的爱情，将价值连城的"海洋之心"钻石抛入大海。詹姆斯·卡梅隆的这部爱情灾难史诗创造了当时的影史票房纪录。',
    director: '詹姆斯·卡梅隆',
    cast: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    duration: '194分钟',
    region: '美国',
    language: '英语',
    releaseDate: '1997-12-19',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20disaster%20movie%20poster%2C%20couple%20embracing%20on%20ship%20bow%20at%20sunset%2C%20ocean%20vista%2C%20warm%20golden%20sunset%20light%2C%20classic%20romantic%20composition%2C%20vintage%20elegance%2C%20Titanic%20ship%20silhouette&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    tags: ['爱情', '灾难', '经典', '奥斯卡'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-13',
    title: '满江红',
    year: 2023,
    category: ['huayu', 'zuixin'],
    rating: 7.6,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领被迫卷入一场巨大的阴谋之中。',
    longDescription: '南宋绍兴年间，岳飞死后四年，秦桧奉命与金国和谈。和谈前夜，金国使者死在宰相秦桧的驻地，所携密信不翼而飞。小兵张大和亲兵营副统领孙均被卷入这场阴谋。在有限的两个时辰内，两人被迫在秦桧府邸中寻找真相。随着调查深入，一个惊天秘密逐渐浮出水面。张艺谋以独特的叙事手法和视觉风格，将悬疑、喜剧和历史融为一体，创造了令人意想不到的观影体验。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-01-22',
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20mystery%20movie%20poster%2C%20ancient%20Chinese%20courtyard%20with%20lanterns%2C%20intrigue%20and%20conspiracy%20theme%2C%20dark%20red%20and%20black%20color%20scheme%2C%20Song%20Dynasty%20aesthetic%2C%20soldiers%20in%20traditional%20armor%2C%20dramatic%20shadows&width=600&height=900&seq=movie-poster-13&orientation=portrait',
    tags: ['悬疑', '喜剧', '历史', '张艺谋'],
    featured: false,
    isNew: true,
    isClassic: false,
  },
  {
    id: 'movie-14',
    title: '霸王别姬',
    year: 1993,
    category: ['huayu', 'jingdian', 'gaofen'],
    rating: 9.6,
    description: '两个京剧伶人半个世纪的悲欢离合，从民国到文革，段小楼与程蝶衣的命运与时代紧紧纠缠。',
    longDescription: '1924年冬天，9岁的小豆子被做妓女的母亲切掉畸形的手指后，进入关家戏班学戏。在戏班中，他与师兄小石头结下深厚情谊。十年后，两人分别取艺名程蝶衣和段小楼，因合演《霸王别姬》而名震京城。程蝶衣人戏不分，将对段小楼的感情融入戏中，而段小楼却娶了妓女菊仙。三人之间复杂的感情在半个世纪的中国历史变迁中沉浮。陈凯歌导演以精湛的叙事和深刻的人文关怀，创作了这部被誉为中国电影巅峰的经典。',
    director: '陈凯歌',
    cast: ['张国荣', '张丰毅', '巩俐', '葛优'],
    duration: '171分钟',
    region: '中国大陆/香港',
    language: '汉语普通话',
    releaseDate: '1993-01-01',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Peking%20opera%20movie%20poster%20style%2C%20elaborate%20opera%20costume%20and%20makeup%2C%20tragic%20beauty%2C%20traditional%20Chinese%20stage%20setting%2C%20golden%20and%20red%20color%20palette%2C%20dramatic%20theatrical%20lighting%2C%20artistic%20cinematography&width=600&height=900&seq=movie-poster-14&orientation=portrait',
    tags: ['剧情', '历史', '爱情', '经典'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-15',
    title: '小丑',
    year: 2019,
    category: ['oumei', 'gaofen'],
    rating: 8.7,
    description: '亚瑟·弗莱克是一个被社会忽视的喜剧演员，在一连串的打击下，他逐渐蜕变为哥谭市最危险的罪犯——小丑。',
    longDescription: '故事设定在1981年的哥谭市。亚瑟·弗莱克是一个与母亲同住的职业小丑演员，患有罕见的神经系统疾病，会不受控制地大笑。他梦想成为一名脱口秀喜剧演员，但生活处处碰壁——被街头混混殴打、被同事陷害、被偶像在电视上嘲笑。当社会服务被削减，他失去了心理咨询和药物治疗。在一连串的打击下，亚瑟的精神防线彻底崩溃，他在地铁上射杀了三名骚扰他的华尔街精英，意外成为了哥谭底层民众反抗的象征。托德·菲利普斯的这部心理惊悚片以残酷的社会批判和震撼的表演，获得了威尼斯电影节金狮奖。',
    director: '托德·菲利普斯',
    cast: ['华金·菲尼克斯', '罗伯特·德尼罗'],
    duration: '122分钟',
    region: '美国',
    language: '英语',
    releaseDate: '2019-10-04',
    image: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20thriller%20movie%20poster%2C%20clown%20makeup%20on%20distorted%20face%2C%20staircase%20dancing%20scene%2C%20grimy%20urban%201980s%20aesthetic%2C%20vibrant%20contrasting%20colors%2C%20yellow%20and%20purple%20and%20red%2C%20deranged%20expression&width=600&height=900&seq=movie-poster-15&orientation=portrait',
    tags: ['剧情', '犯罪', '心理', '威尼斯金狮'],
    featured: false,
    isNew: false,
    isClassic: false,
  },
  {
    id: 'movie-16',
    title: '哈利·波特与魔法石',
    year: 2001,
    category: ['oumei', 'jingdian'],
    rating: 9.1,
    description: '11岁的哈利·波特收到霍格沃茨魔法学校的入学通知书，从此踏入了一个充满魔法与冒险的奇幻世界。',
    longDescription: '从小寄养在姨丈家的哈利·波特饱受欺凌，在11岁生日那天，他收到了霍格沃茨魔法学校的入学通知书。原来哈利的父母都是伟大的魔法师，在对付伏地魔的战斗中双双牺牲，只有哈利幸存。在霍格沃茨，哈利结识了好友罗恩和赫敏，学习魔法知识，发现自己的身世之谜，并冒险阻止伏地魔偷取可以让人长生不老的魔法石。这部J.K.罗琳小说改编的电影开启了全球最成功的奇幻系列之一。',
    director: '克里斯·哥伦布',
    cast: ['丹尼尔·雷德克里夫', '艾玛·沃特森', '鲁伯特·格林特'],
    duration: '152分钟',
    region: '美国/英国',
    language: '英语',
    releaseDate: '2001-11-16',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20movie%20poster%20for%20magical%20school%2C%20young%20wizard%20with%20round%20glasses%2C%20Hogwarts%20castle%20silhouette%2C%20golden%20snitch%2C%20warm%20magical%20glow%2C%20mysterious%20atmosphere%2C%20dark%20blue%20and%20gold%20color%20scheme&width=600&height=900&seq=movie-poster-16&orientation=portrait',
    tags: ['奇幻', '冒险', '魔法', '系列'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-17',
    title: '铃芽之旅',
    year: 2023,
    category: ['rihan', 'zuixin'],
    rating: 7.7,
    description: '17岁少女铃芽在九州的一个宁静小镇上遇到了寻找门的青年宗像草太，两人一同踏上了关闭灾祸之门的旅程。',
    longDescription: '生活在九州宫崎县的17岁少女岩户铃芽，某天遇到了一位寻找废墟中"门"的神秘青年宗像草太。铃芽跟随他来到山中废墟，发现了一扇古老的白色之门。她像是被什么东西吸引一样，伸手打开了那扇门。之后，日本各地开始出现更多的门，如果不及时关闭，门那边的灾厄就会降临。铃芽和草太踏上了环游日本关闭灾厄之门的旅程。新海诚以公路片的形式，将日本各地的美景、311地震的创伤记忆和一个少女的成长故事融为一体。',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗'],
    duration: '122分钟',
    region: '日本',
    language: '日语',
    releaseDate: '2023-03-24',
    image: 'https://readdy.ai/api/search-image?query=Anime%20road%20movie%20poster%2C%20Japanese%20high%20school%20girl%20with%20chair%20companion%20traveling%20through%20beautiful%20Japanese%20landscapes%2C%20door%20in%20ruins%2C%20vibrant%20blue%20sky%20and%20sea%2C%20adventure%20spirit%2C%20warm%20sunlight&width=600&height=900&seq=movie-poster-17&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '公路片'],
    featured: false,
    isNew: true,
    isClassic: false,
  },
  {
    id: 'movie-18',
    title: '阿甘正传',
    year: 1994,
    category: ['oumei', 'jingdian', 'gaofen'],
    rating: 9.5,
    description: '智商只有75的阿甘，以纯真的视角经历了美国几十年的历史变迁，创造了属于自己的传奇人生。',
    longDescription: '阿甘是一个智商只有75的阿拉巴马州男孩，但他有一位伟大的母亲。母亲告诉他"人生就像一盒巧克力，你永远不知道下一颗是什么味道"。阿甘凭借跑步天赋进入了大学，成为橄榄球明星；参军后被派往越南战场，因英勇表现获得荣誉勋章；他教会了猫王跳舞，启发了约翰·列侬的歌曲，投资了苹果公司。他的人生轨迹与20世纪后半叶美国的重要历史事件交织在一起。汤姆·汉克斯以温暖人心的表演，塑造了一个永载影史的经典角色。',
    director: '罗伯特·泽米吉斯',
    cast: ['汤姆·汉克斯', '罗宾·怀特', '加里·西尼斯'],
    duration: '142分钟',
    region: '美国',
    language: '英语',
    releaseDate: '1994-07-06',
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20classic%20movie%20poster%20style%2C%20man%20sitting%20on%20park%20bench%20with%20box%20of%20chocolates%2C%20white%20feather%20floating%2C%20simple%20clean%20composition%2C%20warm%20nostalgic%20tones%2C%20American%20southern%20charm&width=600&height=900&seq=movie-poster-18&orientation=portrait',
    tags: ['剧情', '励志', '经典', '奥斯卡'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
  {
    id: 'movie-19',
    title: '孤注一掷',
    year: 2023,
    category: ['huayu', 'zuixin'],
    rating: 7.1,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱，一场惊心动魄的逃亡之旅。',
    longDescription: '程序员潘生和模特安娜因看似条件优渥的工作机会，决定出国淘金，却意外落入境外诈骗团伙的陷阱。在诈骗工厂中，他们被迫参与网络诈骗活动。为了逃离这个人间地狱，两人决定冒险一搏。影片以真实的网络诈骗案例为蓝本，揭露了境外网络诈骗的残酷内幕，具有强烈的现实警示意义。导演申奥以纪实风格和紧张节奏，打造了一部令人窒息的现实主义犯罪片。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    duration: '130分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-08-08',
    image: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20underground%20scam%20operation%20center%2C%20computers%20and%20wires%2C%20prisoner%20theme%2C%20tense%20atmosphere%2C%20neon%20lighting%20against%20darkness%2C%20Southeast%20Asian%20setting&width=600&height=900&seq=movie-poster-19&orientation=portrait',
    tags: ['犯罪', '剧情', '现实题材'],
    featured: false,
    isNew: true,
    isClassic: false,
  },
  {
    id: 'movie-20',
    title: '龙猫',
    year: 1988,
    category: ['rihan', 'jingdian', 'gaofen'],
    rating: 9.2,
    description: '小月和小梅姐妹随父亲搬到乡下，在那里遇到了只有纯真的孩子才能看见的森林精灵——龙猫。',
    longDescription: '因为母亲生病住院，小月和小梅姐妹跟随父亲搬到乡下的老房子居住。在这片充满神秘气息的森林中，小梅意外发现了一只毛茸茸的巨大生物——龙猫。之后姐妹俩多次与龙猫相遇，乘坐猫巴士穿越田野，在月光下与龙猫一起让橡子发芽长成参天大树。当小梅因担心母亲病情而走失时，龙猫和猫巴士帮助小月找到了妹妹。宫崎骏以温柔的笔触描绘了童年、自然和亲情的纯真美好，这部动画温暖了全世界几代人的心。',
    director: '宫崎骏',
    cast: ['日高法子', '坂本千夏', '糸井重里'],
    duration: '86分钟',
    region: '日本',
    language: '日语',
    releaseDate: '1988-04-16',
    image: 'https://readdy.ai/api/search-image?query=Whimsical%20Studio%20Ghibli%20anime%20poster%20style%2C%20large%20fluffy%20forest%20spirit%20creature%20with%20two%20little%20girls%2C%20Japanese%20countryside%2C%20lush%20green%20forest%2C%20rainy%20night%20bus%20stop%2C%20warm%20and%20nostalgic%2C%20children%20book%20illustration%20style&width=600&height=900&seq=movie-poster-20&orientation=portrait',
    tags: ['动画', '奇幻', '亲情', '治愈'],
    featured: false,
    isNew: false,
    isClassic: true,
  },
];

export function getMoviesByCategory(categoryKey: string): Movie[] {
  if (categoryKey === 'zuixin') {
    return movies.filter(m => m.isNew);
  }
  if (categoryKey === 'jingdian') {
    return movies.filter(m => m.isClassic);
  }
  if (categoryKey === 'gaofen') {
    return movies.filter(m => m.rating >= 8.5);
  }
  return movies.filter(m => m.category.includes(categoryKey));
}

export function getFeaturedMovies(): Movie[] {
  return movies.filter(m => m.featured);
}

export function getLatestMovies(): Movie[] {
  return movies.filter(m => m.isNew);
}

export function getClassicMovies(): Movie[] {
  return movies.filter(m => m.isClassic);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}